export default __webpack_public_path__ + "0f7c6b1e65c72c1943de2c9efd0853cd.png";